import src from "IMAGE";
export default { src, width: 225, height: 294, blurDataURL: null, blurWidth: 0, blurHeight: 0 }
